if (!customElements.get('dope-opening-film')) {
  customElements.define('dope-opening-film', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.video = this.querySelector('[data-opening-film]');
      this.button = this.querySelector('[data-opening-control]');
      if (!this.video || !this.button || !this.video.dataset.src) return;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.label = this.dataset.label || 'the High Roller product film';
      this.inView = false;
      this.autoplay = !this.preference.matches && !this.connection?.saveData;
      this.serial = (this.serial || 0) + 1;
      const poster = this.video.getAttribute('poster');
      if (poster) {
        const image = new Image();
        image.fetchPriority = 'high';
        image.src = poster;
        this.posterReady = image.decode().catch(() => {});
      } else this.posterReady = Promise.resolve();
      this.button.hidden = false;
      const options = {signal:this.abort.signal};
      this.button.addEventListener('click', () => {
        this.autoplay = false;
        if (this.video.paused) this.play(); else this.pause();
      }, options);
      this.video.addEventListener('playing', () => {
        if (document.hidden || !this.inView) this.pause();
        else { this.button.textContent = 'Pause film'; this.button.setAttribute('aria-label','Pause film: ' + this.label); }
      }, options);
      this.video.addEventListener('pause', () => { this.button.textContent = 'Play film'; this.button.setAttribute('aria-label','Play film: ' + this.label); }, options);
      this.video.addEventListener('error', () => { this.autoplay = false; this.pause(); }, options);
      this.preference.addEventListener('change', () => {
        if (this.preference.matches) { this.autoplay = false; this.pause(); }
      }, options);
      this.connection?.addEventListener?.('change', () => {
        if (this.connection.saveData) { this.autoplay = false; this.pause(); }
      }, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.pause(); }, options);
      this.observer?.disconnect();
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries.some(e => e.target === this && e.isIntersecting && e.intersectionRatio >= .15);
          if (!this.inView) this.pause();
          else if (this.autoplay && !document.hidden) this.play({automatic:true});
        }, {threshold:[0,.15]});
        this.observer.observe(this);
      } else { this.inView = true; if (this.autoplay) this.play({automatic:true}); }
    }
    async play({automatic=false}={}) {
      if (!this.isConnected || document.hidden || !this.inView) return;
      const serial = ++this.serial;
      if (automatic) {
        await this.posterReady;
        // Give the decoded opening image a paint before starting the film.
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        if (serial !== this.serial || !this.isConnected || document.hidden || !this.inView || !this.autoplay) return;
      }
      if (!this.video.getAttribute('src') || this.video.error) {
        // Pick one rendition on first play; resizing must not restart a film.
        this.video.src = matchMedia('(max-width: 767px)').matches && this.video.dataset.srcMobile || this.video.dataset.src;
        this.video.load();
      }
      try {
        await this.video.play();
        if (serial !== this.serial) return;
        if (document.hidden || !this.inView) this.video.pause();
        else { this.button.textContent = 'Pause film'; this.button.setAttribute('aria-label','Pause film: ' + this.label); }
      } catch { if (serial === this.serial) { this.autoplay = false; this.pause(); } }
    }
    pause() {
      ++this.serial;
      this.video?.pause();
      if (this.button) { this.button.textContent = 'Play film'; this.button.setAttribute('aria-label','Play film: ' + this.label); }
    }
    disconnectedCallback() {
      this.pause(); this.observer?.disconnect(); this.abort?.abort();
      this.video?.removeAttribute('src'); this.video?.load();
    }
  });
}
